/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { calendersCreateCalenderEventGet } from '../fn/calenders/calenders-create-calender-event-get';
import { CalendersCreateCalenderEventGet$Params } from '../fn/calenders/calenders-create-calender-event-get';
import { calendersCreateCalenderEventPost } from '../fn/calenders/calenders-create-calender-event-post';
import { CalendersCreateCalenderEventPost$Params } from '../fn/calenders/calenders-create-calender-event-post';
import { calendersCreateCalenderOrganizationEventGet } from '../fn/calenders/calenders-create-calender-organization-event-get';
import { CalendersCreateCalenderOrganizationEventGet$Params } from '../fn/calenders/calenders-create-calender-organization-event-get';
import { calendersCreateCalenderOrganizationEventPost } from '../fn/calenders/calenders-create-calender-organization-event-post';
import { CalendersCreateCalenderOrganizationEventPost$Params } from '../fn/calenders/calenders-create-calender-organization-event-post';
import { calendersDeleteCalenderEvent } from '../fn/calenders/calenders-delete-calender-event';
import { CalendersDeleteCalenderEvent$Params } from '../fn/calenders/calenders-delete-calender-event';
import { calendersDeleteCalenderOrganizationEventCommand } from '../fn/calenders/calenders-delete-calender-organization-event-command';
import { CalendersDeleteCalenderOrganizationEventCommand$Params } from '../fn/calenders/calenders-delete-calender-organization-event-command';
import { calendersGetCalenderByDateTime } from '../fn/calenders/calenders-get-calender-by-date-time';
import { CalendersGetCalenderByDateTime$Params } from '../fn/calenders/calenders-get-calender-by-date-time';
import { calendersGetCalenderByMonthAndYear } from '../fn/calenders/calenders-get-calender-by-month-and-year';
import { CalendersGetCalenderByMonthAndYear$Params } from '../fn/calenders/calenders-get-calender-by-month-and-year';
import { calendersUpdateCalender } from '../fn/calenders/calenders-update-calender';
import { CalendersUpdateCalender$Params } from '../fn/calenders/calenders-update-calender';
import { calendersUpdateCalenderDescription } from '../fn/calenders/calenders-update-calender-description';
import { CalendersUpdateCalenderDescription$Params } from '../fn/calenders/calenders-update-calender-description';
import { calendersUpdateCalenderEvent } from '../fn/calenders/calenders-update-calender-event';
import { CalendersUpdateCalenderEvent$Params } from '../fn/calenders/calenders-update-calender-event';
import { calendersUpdateCalenderOrganizationEvent } from '../fn/calenders/calenders-update-calender-organization-event';
import { CalendersUpdateCalenderOrganizationEvent$Params } from '../fn/calenders/calenders-update-calender-organization-event';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfListOfGetCalenderByDateTImeDto } from '../models/custom-result-of-list-of-get-calender-by-date-t-ime-dto';
import { CustomResultOfListOfGetCalenderByMonthAndYearDto } from '../models/custom-result-of-list-of-get-calender-by-month-and-year-dto';

@Injectable({ providedIn: 'root' })
export class CalendersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `calendersCreateCalenderOrganizationEventGet()` */
  static readonly CalendersCreateCalenderOrganizationEventGetPath = '/Calenders/CreateCalenderOrganizationEvent';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersCreateCalenderOrganizationEventGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  calendersCreateCalenderOrganizationEventGet$Response(params?: CalendersCreateCalenderOrganizationEventGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return calendersCreateCalenderOrganizationEventGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersCreateCalenderOrganizationEventGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calendersCreateCalenderOrganizationEventGet(params?: CalendersCreateCalenderOrganizationEventGet$Params, context?: HttpContext): Observable<Blob> {
    return this.calendersCreateCalenderOrganizationEventGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `calendersCreateCalenderOrganizationEventPost()` */
  static readonly CalendersCreateCalenderOrganizationEventPostPath = '/Calenders/CreateCalenderOrganizationEvent';

  /**
   * ایجاد مناسبت سازمانی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersCreateCalenderOrganizationEventPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersCreateCalenderOrganizationEventPost$Response(params: CalendersCreateCalenderOrganizationEventPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return calendersCreateCalenderOrganizationEventPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد مناسبت سازمانی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersCreateCalenderOrganizationEventPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersCreateCalenderOrganizationEventPost(params: CalendersCreateCalenderOrganizationEventPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.calendersCreateCalenderOrganizationEventPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `calendersUpdateCalenderOrganizationEvent()` */
  static readonly CalendersUpdateCalenderOrganizationEventPath = '/Calenders/UpdateCalenderOrganizationEvent';

  /**
   * ویرایش مناسبت سازمانی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersUpdateCalenderOrganizationEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersUpdateCalenderOrganizationEvent$Response(params: CalendersUpdateCalenderOrganizationEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return calendersUpdateCalenderOrganizationEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش مناسبت سازمانی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersUpdateCalenderOrganizationEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersUpdateCalenderOrganizationEvent(params: CalendersUpdateCalenderOrganizationEvent$Params, context?: HttpContext): Observable<CustomResult> {
    return this.calendersUpdateCalenderOrganizationEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `calendersDeleteCalenderOrganizationEventCommand()` */
  static readonly CalendersDeleteCalenderOrganizationEventCommandPath = '/Calenders/DeleteCalenderOrganizationEventCommand';

  /**
   * حذف مناسبت سازمانی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersDeleteCalenderOrganizationEventCommand()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersDeleteCalenderOrganizationEventCommand$Response(params: CalendersDeleteCalenderOrganizationEventCommand$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return calendersDeleteCalenderOrganizationEventCommand(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف مناسبت سازمانی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersDeleteCalenderOrganizationEventCommand$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersDeleteCalenderOrganizationEventCommand(params: CalendersDeleteCalenderOrganizationEventCommand$Params, context?: HttpContext): Observable<CustomResult> {
    return this.calendersDeleteCalenderOrganizationEventCommand$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `calendersCreateCalenderEventGet()` */
  static readonly CalendersCreateCalenderEventGetPath = '/Calenders/CreateCalenderEvent';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersCreateCalenderEventGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  calendersCreateCalenderEventGet$Response(params?: CalendersCreateCalenderEventGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return calendersCreateCalenderEventGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersCreateCalenderEventGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calendersCreateCalenderEventGet(params?: CalendersCreateCalenderEventGet$Params, context?: HttpContext): Observable<Blob> {
    return this.calendersCreateCalenderEventGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `calendersCreateCalenderEventPost()` */
  static readonly CalendersCreateCalenderEventPostPath = '/Calenders/CreateCalenderEvent';

  /**
   * ایجاد مناسبت تقویمی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersCreateCalenderEventPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersCreateCalenderEventPost$Response(params: CalendersCreateCalenderEventPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return calendersCreateCalenderEventPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد مناسبت تقویمی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersCreateCalenderEventPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersCreateCalenderEventPost(params: CalendersCreateCalenderEventPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.calendersCreateCalenderEventPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `calendersUpdateCalenderEvent()` */
  static readonly CalendersUpdateCalenderEventPath = '/Calenders/UpdateCalenderEvent';

  /**
   * ویرایش مناسبت تقویمی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersUpdateCalenderEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersUpdateCalenderEvent$Response(params: CalendersUpdateCalenderEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return calendersUpdateCalenderEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش مناسبت تقویمی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersUpdateCalenderEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersUpdateCalenderEvent(params: CalendersUpdateCalenderEvent$Params, context?: HttpContext): Observable<CustomResult> {
    return this.calendersUpdateCalenderEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `calendersDeleteCalenderEvent()` */
  static readonly CalendersDeleteCalenderEventPath = '/Calenders/DeleteCalenderEvent';

  /**
   * حذف مناسبت تقویمی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersDeleteCalenderEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersDeleteCalenderEvent$Response(params: CalendersDeleteCalenderEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return calendersDeleteCalenderEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف مناسبت تقویمی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersDeleteCalenderEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersDeleteCalenderEvent(params: CalendersDeleteCalenderEvent$Params, context?: HttpContext): Observable<CustomResult> {
    return this.calendersDeleteCalenderEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `calendersUpdateCalender()` */
  static readonly CalendersUpdateCalenderPath = '/Calenders/UpdateCalender';

  /**
   * ویرایش تقویم.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersUpdateCalender()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersUpdateCalender$Response(params: CalendersUpdateCalender$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return calendersUpdateCalender(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش تقویم.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersUpdateCalender$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersUpdateCalender(params: CalendersUpdateCalender$Params, context?: HttpContext): Observable<CustomResult> {
    return this.calendersUpdateCalender$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `calendersUpdateCalenderDescription()` */
  static readonly CalendersUpdateCalenderDescriptionPath = '/Calenders/UpdateCalenderDescription';

  /**
   * ویرایش توضیحات تقویم.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersUpdateCalenderDescription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersUpdateCalenderDescription$Response(params: CalendersUpdateCalenderDescription$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return calendersUpdateCalenderDescription(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش توضیحات تقویم.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersUpdateCalenderDescription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calendersUpdateCalenderDescription(params: CalendersUpdateCalenderDescription$Params, context?: HttpContext): Observable<CustomResult> {
    return this.calendersUpdateCalenderDescription$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `calendersGetCalenderByMonthAndYear()` */
  static readonly CalendersGetCalenderByMonthAndYearPath = '/Calenders/GetCalenderByMonthAndYear';

  /**
   * دریافت تقویم ماهانه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersGetCalenderByMonthAndYear()` instead.
   *
   * This method doesn't expect any request body.
   */
  calendersGetCalenderByMonthAndYear$Response(params?: CalendersGetCalenderByMonthAndYear$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCalenderByMonthAndYearDto>> {
    return calendersGetCalenderByMonthAndYear(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تقویم ماهانه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersGetCalenderByMonthAndYear$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calendersGetCalenderByMonthAndYear(params?: CalendersGetCalenderByMonthAndYear$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCalenderByMonthAndYearDto> {
    return this.calendersGetCalenderByMonthAndYear$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCalenderByMonthAndYearDto>): CustomResultOfListOfGetCalenderByMonthAndYearDto => r.body)
    );
  }

  /** Path part for operation `calendersGetCalenderByDateTime()` */
  static readonly CalendersGetCalenderByDateTimePath = '/Calenders/GetCalenderByDateTime';

  /**
   * دریافت تقویم بر اساس تاریخ.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calendersGetCalenderByDateTime()` instead.
   *
   * This method doesn't expect any request body.
   */
  calendersGetCalenderByDateTime$Response(params?: CalendersGetCalenderByDateTime$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCalenderByDateTImeDto>> {
    return calendersGetCalenderByDateTime(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تقویم بر اساس تاریخ.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calendersGetCalenderByDateTime$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calendersGetCalenderByDateTime(params?: CalendersGetCalenderByDateTime$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCalenderByDateTImeDto> {
    return this.calendersGetCalenderByDateTime$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCalenderByDateTImeDto>): CustomResultOfListOfGetCalenderByDateTImeDto => r.body)
    );
  }

}
